export default {
    data:{
        routeRecordNum:30,
        routeHistory:[],
    },
    watch:{
        routeHistory:function (e){
            if(e.length > this.routeRecordNum){
                let tempArr = [];
                for(let i=(e.length-this.routeRecordNum);i<e.length;i++){
                    tempArr.push(e[i]);
                }
                this.routeHistory = tempArr;
            }

        },
    },
    methods:{

    }



}


// WEBPACK FOOTER //
// ./src/controller/route/multiple.js